// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboard-container {
  width: 100%;
  min-height: 80vh;
}

.dashboard-date-container{
  margin-left: 0.8em;
}

/* Buttons Styling*/
.options-container {
  display: flex;
  flex-wrap: wrap; /* Allow wrapping of child elements */
  gap: 1em; /* Add space between child elements */
  margin: 0.25em 0 0 0.8em;
}

/* CUSTOM BUTTON STYLING */

/* create-buttons */
.create-button-style{
  background-color: #539165 !important;
  color: white;
  text-transform: capitalize;
}

/* save-buttons */
.save-button-style{
  background-color: #3F497F !important;
  color: white;
  text-transform: capitalize;
}

/* cancel-buttons */
.cancel-button-style{
  background-color: #F0A04B !important;
  color: white;
  text-transform: capitalize;
}

/* delete-buttons */
.delete-button-style{
  background-color: #FA7070 !important;
  color: white;
  text-transform: capitalize;
}

.button-selection:hover{
  background-color: whitesmoke !important;
  border-color: #3F497F;
  transition: 0.4s;
  color: black;
}



/* EDIT BUTTONS */

.edit-buttons-container {
  display: flex;
  gap: 0.8em;
  align-items: end;
}

.name-container{
  width: 12em;
}

.loader-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh; /* Adjust as needed */
}

.loader {
  border: 4px solid #f3f3f3; /* Light grey */
  border-top: 4px solid #3F497F; /* Blue */
  border-radius: 50%;
  width: 30px;
  height: 30px;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
`, "",{"version":3,"sources":["webpack://./src/components/dashboard/dashboard.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,eAAe,EAAE,qCAAqC;EACtD,QAAQ,EAAE,qCAAqC;EAC/C,wBAAwB;AAC1B;;AAEA,0BAA0B;;AAE1B,mBAAmB;AACnB;EACE,oCAAoC;EACpC,YAAY;EACZ,0BAA0B;AAC5B;;AAEA,iBAAiB;AACjB;EACE,oCAAoC;EACpC,YAAY;EACZ,0BAA0B;AAC5B;;AAEA,mBAAmB;AACnB;EACE,oCAAoC;EACpC,YAAY;EACZ,0BAA0B;AAC5B;;AAEA,mBAAmB;AACnB;EACE,oCAAoC;EACpC,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;EACE,uCAAuC;EACvC,qBAAqB;EACrB,gBAAgB;EAChB,YAAY;AACd;;;;AAIA,iBAAiB;;AAEjB;EACE,aAAa;EACb,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa,EAAE,qBAAqB;AACtC;;AAEA;EACE,yBAAyB,EAAE,eAAe;EAC1C,6BAA6B,EAAE,SAAS;EACxC,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kCAAkC;AACpC;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC","sourcesContent":[".dashboard-container {\n  width: 100%;\n  min-height: 80vh;\n}\n\n.dashboard-date-container{\n  margin-left: 0.8em;\n}\n\n/* Buttons Styling*/\n.options-container {\n  display: flex;\n  flex-wrap: wrap; /* Allow wrapping of child elements */\n  gap: 1em; /* Add space between child elements */\n  margin: 0.25em 0 0 0.8em;\n}\n\n/* CUSTOM BUTTON STYLING */\n\n/* create-buttons */\n.create-button-style{\n  background-color: #539165 !important;\n  color: white;\n  text-transform: capitalize;\n}\n\n/* save-buttons */\n.save-button-style{\n  background-color: #3F497F !important;\n  color: white;\n  text-transform: capitalize;\n}\n\n/* cancel-buttons */\n.cancel-button-style{\n  background-color: #F0A04B !important;\n  color: white;\n  text-transform: capitalize;\n}\n\n/* delete-buttons */\n.delete-button-style{\n  background-color: #FA7070 !important;\n  color: white;\n  text-transform: capitalize;\n}\n\n.button-selection:hover{\n  background-color: whitesmoke !important;\n  border-color: #3F497F;\n  transition: 0.4s;\n  color: black;\n}\n\n\n\n/* EDIT BUTTONS */\n\n.edit-buttons-container {\n  display: flex;\n  gap: 0.8em;\n  align-items: end;\n}\n\n.name-container{\n  width: 12em;\n}\n\n.loader-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100vh; /* Adjust as needed */\n}\n\n.loader {\n  border: 4px solid #f3f3f3; /* Light grey */\n  border-top: 4px solid #3F497F; /* Blue */\n  border-radius: 50%;\n  width: 30px;\n  height: 30px;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
